import { axios } from '@/utils/request'

const api = {
  Pre: '/index.php/Orders/pre',
  List: '/index.php/Orders/getList',
  GetDictByCourse: '/index.php/Orders/getDictByCourse'
}

// 预加载
export function getPre () {
  return axios({
    url: api.Pre,
    method: 'get'
  })
}

export function getList (parameter) {
  return axios({
    url: api.List,
    method: 'get',
    params: parameter
  })
}

export function getDictByCourse (parameter) {
  return axios({
    url: api.GetDictByCourse,
    method: 'get',
    params: parameter
  })
}
